import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type FileOperationEvent = 'refresh' | 'deleted';

@Injectable({ providedIn: 'root' })
export class FileOperationEventsService {
  private fileOperationSubject = new Subject<FileOperationEvent>();
  fileOperation$ = this.fileOperationSubject.asObservable();

  emit(event: FileOperationEvent) {
    this.fileOperationSubject.next(event);
  }
} 